<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Container, Modal, Text, Alert, Button } from '@Shelly/shelly-design-system';
	import PremiumBenefits from './PremiumBenefits.svelte';
	import { push } from 'svelte-spa-router';
	import { save_profile } from 'src/helpers/profile_helpers';
	import { dateFormat } from 'src/helpers/date_helper';
	import { createEventDispatcher } from 'svelte';
	export let showModal = true;
	export let nextBillingTime = '';
	export let priority = 70;

	const dispatch = createEventDispatcher();

	$: expiringTenDays = `<span class="text-bold">${$format('span_expiring_ten_days', {
		default: 'expiring in 10 days',
	})}</span>`;
	$: expiringText = $format('text_expiring_ten_days', {
		default:
			'Your Shelly Premium subscription is {expiringTenDays}. To keep enjoying premium features and your configurations, simply renew your subscription before {expiringDate}.',
		values: {
			expiringTenDays,
			expiringDate: dateFormat(new Date(nextBillingTime), 'd M, Y'),
		},
	});

	const closeModal = () => {
		save_profile('isShowedExpirationPremium', 'yes');
		dispatch('close');
	};
</script>

<Modal
	{showModal}
	on:close={() => closeModal()}
	title={$format('title_premium_ten_days_left', {
		default: '10 days left in Premium',
	})}
	zIndex={priority}
>
	<Container slot="content" padding="0">
		<div class="d-flex align-items-center flex-direction-column">
			<img class="mb-m" src="./images/ten_days_left_premium.svg" alt="ten-days-left-premium" />
			<p class="mb-m h1-styles text-center">
				{$format('text_premium_perks_ending_soon', {
					default: 'Your Premium Perks are Ending Soon!',
				})}
			</p>
		</div>
		<Text class="mb-m text-center">{@html expiringText}</Text>
		<Alert
			type="warning"
			heading={$format('text_premium_please_note', {
				default:
					'Please note that if you reactivate your Premium membership after the billing period ends, you will not automatically regain these settings and configurations. You will need to set them up again from scratch.',
			})}
			class="mb-m"
		/>
		<div class="text-center mb-m">
			<Button
				variant="premium"
				class="text-600 text-capitalize"
				on:click={() => {
					push('/settings/premium');
					closeModal();
				}}
			>
				{$format('button_renew_premium', { default: 'Renew Premium' })}
			</Button>
		</div>
		<Text class="text-bold text-center"
			>{$format('sub_text_premium_expiration', {
				default: 'If you don’t renew before {expiringDate}',
				values: {
					expiringDate: dateFormat(new Date(nextBillingTime), 'd M, Y'),
				},
			})}</Text
		>
		<Text class="mb-m text-bold text-center"
			>{$format('second_sub_text_premium_expiration', {
				default: 'you’ll lose access and your configurations for:',
			})}</Text
		>
		<PremiumBenefits />
	</Container>
</Modal>
